import { left } from 'fp-ts/Either';
import { httpClientFunction } from 'domain/types';
import { UpdateDashboardStarClient } from 'use-case/dashboard/update/updateDashboardClient';

import { callbackParseDashboardResponse } from 'adapter/out/client/dashboard/callbackParseDashboardResponse';
import { UpdateDashboardStarCriteria } from 'use-case/dashboard/update/updateDashboardCriteria/updateDashboardStarCriteria';

export default (httpClient: httpClientFunction, baseUrl: string): UpdateDashboardStarClient => (criteria: UpdateDashboardStarCriteria) =>
    httpClient(`${baseUrl}/dashboards/dashboards/${criteria.id}/star`, {
        method: 'POST',
        body: JSON.stringify(asDashboardJson(criteria)),
        headers: { 'Content-Type': 'application/json' },
    })
        .then((response) => callbackParseDashboardResponse(response))
        .catch(() => left({ error: new Error(), status: 503 }));

export const asDashboardJson = (criteria: UpdateDashboardStarCriteria): DashboardUpdateStarJsonRequest => ({
    starred: criteria.starred,
});

export type DashboardUpdateStarJsonRequest = {
    starred: boolean;
};
